import * as React from 'react';
import {
  Modal,
} from 'src/Library/AntdLibComponents';

interface IProps {
  isVisible?: boolean;
  onCancel: () => void;
  handleDelete: () => void;
  isRequestDeleting?: boolean;
}

const SEDeleteOdexDraftModal = (props: IProps): React.ReactElement => {

  const {
    isVisible,
    isRequestDeleting,
    handleDelete,
    onCancel,
  } = props;

  return (
    <Modal
      title="Confirmation"
      confirmLoading={isRequestDeleting}
      visible={isVisible}
      onOk={handleDelete}
      width={350}
      okText="Yes"
      cancelText="No"
      onCancel={onCancel}
    >
      Are you sure you want to delete this draft?
    </Modal>
  );
};

export default React.memo(SEDeleteOdexDraftModal);
